import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseCustomDialog } from '../base-custom-dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';
import { IBrokeringTarget } from '../../../../models/action.model';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'fi-lead-broker-start',
  templateUrl: './lead-broker-start.component.html',
  styleUrls: ['./lead-broker-start.component.scss'],
  standalone: false,
})
export class LeadBrokerStartComponent extends BaseCustomDialog implements OnInit {
  leadId: number;
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_BROKER_START', false);
  targets: IBrokeringTarget[] = [];
  firstWaveTargets: IBrokeringTarget[] = [];
  secondWaveTargets: IBrokeringTarget[] = [];
  maxAcceptedPartners: number;
  maxAllowedPartners = 0;
  maxAcceptedPartnersInvalid = false;
  formIsValid = false;
  loading = false;
  submitting = false;
  hasLoadError = false;

  private secondWaveDetailMinutes = 240;

  constructor(
    public dialogRef: MatDialogRef<LeadBrokerStartComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { leadId: number, title: string },
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
  }

  ngOnInit(): void {
    this.loadBrokeringTargets();
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  submit(): void {
    if ( !this.formIsValid ) {
      return;
    }

    this.submitting = true;
    this.updateValidationState();
    this.actionDataService.startBrokering(this.leadId, this.maxAcceptedPartners, this.secondWaveDetailMinutes)
      .subscribe(( { success } ) => {
        if ( success ) {
          this.clearClassAndCloseDialog(this.dialogRef, 'remove');
        }

        this.submitting = false;
        this.updateValidationState();
      });
  }

  onMaxAcceptedPartnersChange( value: string | number ): void {
    this.maxAcceptedPartners = Number(value);
    this.updateValidationState();
  }

  private loadBrokeringTargets(): void {
    this.loading = true;
    this.hasLoadError = false;
    this.updateValidationState();

    this.actionDataService.getBrokeringTargets(this.leadId).subscribe(( { success, data } ) => {
      if ( success ) {
        this.setTargets(this.normalizeTargets(data));
        this.maxAcceptedPartners = Math.min(3, this.targets.length);
      } else {
        this.hasLoadError = true;
      }

      this.loading = false;
      this.updateValidationState();
    });
  }

  private setTargets( targets: IBrokeringTarget[] ): void {
    this.targets = targets;
    this.maxAllowedPartners = targets.length;
    this.firstWaveTargets = targets.filter(target => target.IncludedInFirstWave);
    this.secondWaveTargets = targets.filter(target => !target.IncludedInFirstWave);
  }

  private normalizeTargets( data: IBrokeringTarget[] | any ): IBrokeringTarget[] {
    if ( Array.isArray(data) ) {
      return data;
    }

    return data?.BrokeringTargets || [];
  }

  private updateValidationState(): void {
    this.maxAcceptedPartnersInvalid = !Number.isInteger(this.maxAcceptedPartners)
      || this.maxAcceptedPartners < 1
      || this.maxAcceptedPartners > this.maxAllowedPartners;
    this.formIsValid = !!this.leadId
      && !this.loading
      && !this.submitting
      && !!this.targets.length
      && !this.maxAcceptedPartnersInvalid;
  }
}
